var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Auth } from 'aws-amplify';
import * as Sentry from '@sentry/react';
function setUserSentry() {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const current = yield Auth.currentAuthenticatedUser();
            if ((_a = current === null || current === void 0 ? void 0 : current.attributes) === null || _a === void 0 ? void 0 : _a.email) {
                const data = {
                    email: (_b = current === null || current === void 0 ? void 0 : current.attributes) === null || _b === void 0 ? void 0 : _b.email,
                    username: current === null || current === void 0 ? void 0 : current.username
                };
                Sentry.setUser(data);
            }
        }
        catch (error) {
            console.error(error);
        }
    });
}
export { setUserSentry };
